import { all, fork } from 'redux-saga/effects'
import generalAccountSaga from './general-account'
import generalResourcesSaga from './general-resources'
import notificationSaga from './notification-saga'

export default function* settingsSagas() {
  yield all([fork(generalAccountSaga), fork(generalResourcesSaga), fork(notificationSaga)])
}
